export const SET_TEMPLATE_FILES = 'SET_TEMPLATE_FILES';
export const CLEAR_TEMPLATE_FILES = 'CLEAR_TEMPLATE_FILES';